import { createContext } from 'react';
import { FieldValues, UseFormReturn } from 'react-hook-form';
import type { Questionnaire } from '@/typings/Questionnaire';
import * as QuestionnaireApiModels from '@/typings/questionnaires-api-models';
import _ from 'lodash';
import { QuestionnaireResponse, UpdateResponseData } from '@/typings/questionnaires-api-models';
import checkFieldValidity from '@helpers/questionnaires/checkFieldValidity';
import { Creditor } from '@/typings/api-models';
import { AiAgent } from './useLoadAiAgents';

export type QuestionnaireContextType = {
  aiAgents: AiAgent[] | null;
  aiAgentsReadyToRun: boolean;
  checkFieldValidity: typeof checkFieldValidity;
  formMethods: UseFormReturn<FieldValues>;
  currentSection: string;
  defaultValues: Record<string, unknown>;
  responseSources: Record<string, QuestionnaireResponse['source']>;
  referenceData: QuestionnaireApiModels.DataReference[];
  setCurrentSection: (sectionId: string) => void;
  getSectionProgress: (sectionId: string, fieldsVisibility: Record<string, boolean>) => number;
  sectionVisibility: Record<string, boolean>;
  setSectionVisibility: (sectionId: string, isVisible: boolean) => void;
  getFieldSource: (fieldKey: string) => QuestionnaireResponse['source'];
  setFieldSource: (fieldKey: string, source: QuestionnaireResponse['source']) => void;
  getAiRequestId: (fieldKey: string) => string | null;
  setAiRequestId: (fieldKey: string, aiRequestId:string) => void;
  setReferenceData: (data: QuestionnaireApiModels.DataReference[]) => void;
  getSubsectionProgress: (
    sectionId: string,
    subsection: string,
    fieldsVisibility: Record<string, boolean>,
  ) => {
    completedFields: number;
    subsectionProgressPercentage: number | null;
    totalFields: number;
  } | null;
  sectionErrors: { [key: string]: boolean };
  setSectionErrors: (errors: { [key: string]: boolean }) => void;
  onSubmit: (responses: UpdateResponseData, isCompleted?: boolean) => Promise<boolean>;
  aiAutofillActions: string[];
  fieldsByKey: Record<string, Questionnaire.Field>;
  fieldsById: Record<string, Questionnaire.Field>;
  userWorkflowId: string | null;
  questionnaireId: string;
  setValue: (arg1: { key: string, value: unknown, source?: QuestionnaireResponse['source'], aiRequestId?:string }) => void;
  refetchCreditors: () => void;
  creditors: Creditor[];
};

const QuestionnaireContext = createContext<QuestionnaireContextType | undefined>(undefined);

export default QuestionnaireContext;